// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `waypoint-help .help-container {
  background-color: rgba(51, 51, 51, 0.7);
  border-radius: var(--border-radius);
  padding: 14px var(--element-spacing);
  box-sizing: border-box;
  width: 170px;
  font-size: 13px;
  overflow: hidden;
  max-height: 43px;
  transition: 0.2s;
  cursor: pointer;
}
waypoint-help .help-container.open {
  max-height: 456px;
}
waypoint-help .help-container.open .trigger {
  border-bottom: 1px var(--motes-white) solid;
}
waypoint-help .help-container.open .trigger svg-icon {
  transform: rotate(180deg);
}
waypoint-help .help-container.disabled {
  opacity: 0.6;
}
waypoint-help .help-container .trigger {
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  padding-bottom: var(--motes-padding);
}
waypoint-help .help-container .trigger svg-icon {
  transform-origin: center;
  transition: 0.2s;
}
waypoint-help .help-container .bullet {
  display: flex;
  flex-direction: column;
  margin-top: var(--element-spacing);
}
waypoint-help .help-container .bullet svg-icon {
  font-size: 20px;
  margin-bottom: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/editor-page/components/waypoint-help/waypoint-help.component.scss"],"names":[],"mappings":"AAEI;EACI,uCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AADR;AAGQ;EACI,iBAAA;AADZ;AAGY;EACI,2CAAA;AADhB;AAGgB;EACI,yBAAA;AADpB;AAMQ;EACI,YAAA;AAJZ;AAOQ;EACI,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,oCAAA;AALZ;AAOY;EACI,wBAAA;EACA,gBAAA;AALhB;AASQ;EACI,aAAA;EACA,sBAAA;EACA,kCAAA;AAPZ;AASY;EACI,eAAA;EACA,kBAAA;AAPhB","sourcesContent":["waypoint-help {\n\n    .help-container {\n        background-color: rgba(51, 51, 51, 0.7);\n        border-radius: var(--border-radius);\n        padding: 14px var(--element-spacing);\n        box-sizing: border-box;\n        width: 170px;\n        font-size: 13px;\n        overflow: hidden;\n        max-height: 43px;\n        transition: 0.2s;\n        cursor: pointer;\n\n        &.open {\n            max-height: 456px;\n\n            .trigger {\n                border-bottom: 1px var(--motes-white) solid;\n\n                svg-icon {\n                    transform: rotate(180deg);\n                }\n            }\n        }\n\n        &.disabled {\n            opacity: 0.6;\n        }\n\n        .trigger {\n            font-weight: bold;\n            display: flex;\n            justify-content: space-between;\n            padding-bottom: var(--motes-padding);\n\n            svg-icon {\n                transform-origin: center;\n                transition: 0.2s;\n            }\n        }\n\n        .bullet {\n            display: flex;\n            flex-direction: column;\n            margin-top: var(--element-spacing);\n\n            svg-icon {\n                font-size: 20px;\n                margin-bottom: 5px;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
